import { z } from 'zod';
import { TILE_IDS } from '../constants.ts';

export const buttonGridConfigSchema = z.object({
  tiles: z.array(z.enum(TILE_IDS)),
  density: z.enum(['2col', '3col']),
});

export const settingsPatchSchema = z.object({
  quick_log_collapsed: z.boolean().optional(),
  button_grid_config: buttonGridConfigSchema.optional(),
  density: z.enum(['2col', '3col']).optional(),
  week_start: z.enum(['monday', 'sunday']).optional(),
  timezone: z.string().nullable().optional(),
  merge_breast: z.boolean().optional(),
  growth_show_curves: z.boolean().optional(),
  growth_reference: z.enum(['nl3', 'nl4', 'nl5', 'who']).optional(),
  growth_show_target_height: z.boolean().optional(),
  sleep_max_minutes: z.number().int().min(15).max(720).optional(),
  feed_max_minutes: z.number().int().min(5).max(300).optional(),
  pump_max_minutes: z.number().int().min(5).max(300).optional(),
  sleep_auto_end_minutes: z.number().int().min(60).max(1440).optional(),
  feed_auto_end_minutes: z.number().int().min(30).max(1440).optional(),
  pump_auto_end_minutes: z.number().int().min(30).max(1440).optional(),
});

export const notificationPrefsPatchSchema = z.object({
  forgot_to_stop: z.boolean().optional(),
  partner_activity: z.boolean().optional(),
  feed_reminders: z.boolean().optional(),
});

export type ButtonGridConfig = z.infer<typeof buttonGridConfigSchema>;
export type SettingsPatch = z.infer<typeof settingsPatchSchema>;
export type NotificationPrefsPatch = z.infer<typeof notificationPrefsPatchSchema>;
